import React from "react";
import { Section, Brand } from "./../components";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";

export const BrandSection = ({ data, isLoading }) => {
  return isLoading ? (
    <Section title="Brands">
      <SkeletonTheme color="#202020" highlightColor="#444">
        <Skeleton count={3} />
      </SkeletonTheme>
    </Section>
  ) : data?.length > 0 ? (
    <Section title="Brands">
      <div className="d-flex flex-column">
        {data.map((brand, index) => (
          <Brand data={brand} key={`${index}key`} />
        ))}
      </div>
    </Section>
  ) : null;
};
